import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from "../api.js";

export const GetDashboardCountSlice = createAsyncThunk("admin/Dashboard-Count",async (_, { rejectWithValue }) => {
    try {
      const response = await api.DashboardApi();
      console.log("response:",response);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);  
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

const DasshboardCountSlice = createSlice({
  name: 'Dashboard',
  initialState: {
    DashboardCount:[],
    loading: false,
    error: null,
    validationErrors: [],
  },
  reducers: {},
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null; 
      state.validationErrors = []; 
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || []; 
      // toast.error(state.error);
    }

    builder
      .addCase(GetDashboardCountSlice.pending,handlePendingState)
      .addCase(GetDashboardCountSlice.fulfilled, (state, action) => {
        state.DashboardCount = action.payload.data; 
        state.loading = false;
        // toast.success(action?.payload?.message); 
      })
      .addCase(GetDashboardCountSlice.rejected,handleRejectState)
  },
});


export default DasshboardCountSlice.reducer;
